export default __webpack_public_path__ + "static/media/forgot-password.0a988706.jpg";